import { useQuery } from '@tanstack/react-query';
import { SitterBookingWithDetails } from 'happypaws-shared/src/Booking/models/BookingWithDetails';
import { api } from '../../services/api';

export const useGetSitterBookings = () => {
  return useQuery({
    queryKey: ['sitterBookings'],
    queryFn: async () => {
      const response = await api.get<SitterBookingWithDetails[]>('/bookings/sitter');
      return response.data;
    },
    staleTime: 2 * 60 * 1000,
  });
};
